import React, { createContext, useEffect, useState } from 'react';
import {
  IAuthorizationApi,
  NotImplementedAuthorizationApi,
} from '../../api/authorization/IAuthorizationApi';
import {
  ICompanyApi,
  NotImplementedCompanyApi,
} from '../../api/company/ICompanyApi';
import { createApi } from '../../api/createApi';
import {
  IFeedbackApi,
  NotImplementedFeedbackApi,
} from '../../api/feedback/IFeedbackApi';
import {
  IGamificationApi,
  NotImplementedGamificationApi,
} from '../../api/gamification/IGamificationApi';
import { ITeamApi, NotImplementedTeamApi } from '../../api/team/ITeamApi';
import { IUserApi, NotImplementedUserApi } from '../../api/user/IUserApi';
import { Config } from '../../config';
import { useErrorHandler } from '../ErrorHandlerContext/useErrorHandler';
import { useStorageProvider } from '../StorageProviderContext/useStorageProvider';
import {
  IHarmoniaApi,
  NotImplementedHarmoniaApi,
} from '../../api/harmonia/IHarmoniaApi';
import { ISlackApi, NotImplementedSlackApi } from '../../api/slack/ISlackApi';
import {
  ISurveyApi,
  NotImplementedSurveyApi,
} from '../../api/survey/ISurveyApi';

export type ApiContextProps = {
  authApi: IAuthorizationApi;
  userApi: IUserApi;
  teamApi: ITeamApi;
  companyApi: ICompanyApi;
  feedbackApi: IFeedbackApi;
  gamificationApi: IGamificationApi;
  harmoniaApi: IHarmoniaApi;
  slackApi: ISlackApi;
  surveyApi: ISurveyApi;
};

export const ApiContext = createContext<ApiContextProps>({
  authApi: new NotImplementedAuthorizationApi(),
  userApi: new NotImplementedUserApi(),
  teamApi: new NotImplementedTeamApi(),
  companyApi: new NotImplementedCompanyApi(),
  feedbackApi: new NotImplementedFeedbackApi(),
  gamificationApi: new NotImplementedGamificationApi(),
  harmoniaApi: new NotImplementedHarmoniaApi(),
  slackApi: new NotImplementedSlackApi(),
  surveyApi: new NotImplementedSurveyApi(),
});

export const ApiProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const storageProvider = useStorageProvider();
  const errorHandler = useErrorHandler();
  const [authApi, setAuthApi] = useState<IAuthorizationApi>(
    new NotImplementedAuthorizationApi()
  );
  const [userApi, setUserApi] = useState<IUserApi>(new NotImplementedUserApi());
  const [teamApi, setTeamApi] = useState<ITeamApi>(new NotImplementedTeamApi());
  const [feedbackApi, setFeedbackApi] = useState<IFeedbackApi>(
    new NotImplementedFeedbackApi()
  );
  const [gamificationApi, setGamificationApi] = useState<IGamificationApi>(
    new NotImplementedGamificationApi()
  );
  const [companyApi, setCompanyApi] = useState<ICompanyApi>(
    new NotImplementedCompanyApi()
  );

  const [harmoniaApi, setHarmoniaApi] = useState<IHarmoniaApi>(
    new NotImplementedHarmoniaApi()
  );

  const [slackApi, setSlackApi] = useState<ISlackApi>(
    new NotImplementedSlackApi()
  );

  const [surveyApi, setSurveyApi] = useState<ISurveyApi>(
    new NotImplementedSurveyApi()
  );

  useEffect(() => {
    createApi({
      baseUrl: Config.baseUrl,
      storageProvider,
      errorHandler,
    }).then(
      ({
        authorization,
        userApi,
        teamApi,
        companyApi,
        feedbackApi,
        gamificationApi,
        harmoniaApi,
        slackApi,
        surveyApi,
      }) => {
        setAuthApi(authorization);
        setUserApi(userApi);
        setTeamApi(teamApi);
        setCompanyApi(companyApi);
        setFeedbackApi(feedbackApi);
        setFeedbackApi(feedbackApi);
        setGamificationApi(gamificationApi);
        setHarmoniaApi(harmoniaApi);
        setSlackApi(slackApi);
        setSurveyApi(surveyApi);
      }
    );
  }, [errorHandler, storageProvider]);

  return (
    <ApiContext.Provider
      value={{
        authApi,
        userApi,
        teamApi,
        companyApi,
        feedbackApi,
        gamificationApi,
        harmoniaApi,
        slackApi,
        surveyApi,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};
